import React from 'react';
import { Toaster as ReactToaster } from 'react-hot-toast';
const Toaster = () => {
  return <ReactToaster data-sentry-element="ReactToaster" data-sentry-component="Toaster" data-sentry-source-file="index.tsx" />;
};
export default Toaster;